import getcapital from './getcapital';
import Logo from '../Components/svg/myob/Logo';

const theme = getcapital.theme;

export const headerLogo = Logo;

export default {
  theme,
  headerLogo,
};
